export const jobs = {
  listing: {
    title: 'Offres d\'Emploi',
    subtitle: 'Découvrez les meilleures opportunités de carrière',
    results: 'résultats',
    noResults: 'Aucune offre ne correspond à vos critères',
    noResultsDesc: 'Essayez de modifier vos filtres pour voir plus d\'offres',
    clearFilters: 'Effacer les filtres',
    loadMore: 'Charger plus d\'offres',
    filters: {
      title: 'Filtres',
      keywords: 'Mots-clés',
      keywordsPlaceholder: 'Poste, compétences...',
      location: 'Localisation',
      locationPlaceholder: 'Ville, région...',
      category: 'Catégorie',
      categoryAll: 'Toutes les catégories',
      contractType: 'Type de contrat',
      contractAll: 'Tous les types',
      search: 'Rechercher',
      reset: 'Réinitialiser'
    },
    categories: {
      it: 'Informatique & Tech',
      marketing: 'Marketing & Communication',
      sales: 'Ventes & Commerce',
      finance: 'Finance & Comptabilité',
      hr: 'Ressources Humaines',
      engineering: 'Ingénierie',
      healthcare: 'Santé',
      education: 'Éducation',
      logistics: 'Logistique',
      other: 'Autre'
    },
    contracts: {
      cdi: 'CDI',
      cdd: 'CDD',
      stage: 'Stage',
      freelance: 'Freelance',
      alternance: 'Alternance'
    }
  },
  detail: {
    applyNow: 'Postuler maintenant',
    share: 'Partager',
    saved: 'Enregistré',
    save: 'Enregistrer',
    description: 'Description du poste',
    requirements: 'Profil recherché',
    benefits: 'Avantages',
    company: 'À propos de l\'entreprise',
    location: 'Localisation',
    contractType: 'Type de contrat',
    salary: 'Salaire',
    experience: 'Expérience',
    education: 'Formation',
    postedOn: 'Publié le',
    expiresOn: 'Expire le',
    similarJobs: 'Offres similaires',
    backToList: 'Retour aux offres'
  }
};